import { Outlet } from "react-router-dom";
import Nav from "./Nav";
import Footer from "./Footer";
import CookieBanner from "./CookieBanner";
import ScamNotice from "./ScamNotice";
import PageTransition from "./PageTransition";

export default function MarketingLayout() {
  return (
    <div className="grain min-h-screen bg-[#FFFFFF] text-[#0A0A0A]">
      <Nav />
      <main className="relative z-10">
        <PageTransition>
          <Outlet />
        </PageTransition>
      </main>
      <Footer />
      <CookieBanner />
      <ScamNotice />
    </div>
  );
}
